<script setup>
  import { useI18n } from 'vue-i18n'

  import { useSponsors } from '@/features/auth/layout/sponsors/useSponsors.js'
  import FMRGBLogo from '@/features/ui/components/logos/FMRGBLogo.vue'

  const { t } = useI18n()

  const { sponsorLogos } = useSponsors()
</script>

<template>
  <div class="sponsor-list">
    <div class="title">{{ t('thanksToSponsors') }}</div>
    <div class="sponsor-list-items">
      <div v-for="logo of sponsorLogos" :key="logo" class="sponsor-list-item">
        <img :src="logo" alt="Sponsor Logo" />
      </div>

      <div class="to-bottom fm-logo">
        <FMRGBLogo />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .sponsor-list {
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    background: light-dark(#fff, #121212);
    display: flex;
    flex-direction: column;
    width: 210px;

    .title {
      background: var(--fm-ui-auth-layout-primary-color, var(--p-primary-color));
      color: var(--fm-ui-auth-layout-text-color, #fff);
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
  }

  .sponsor-list-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    overflow-y: auto;
    align-items: center;
    height: 100%;
    background: light-dark(#fff, #121212);

    img {
      max-width: 100%;
      height: auto;
    }

    .to-bottom {
      margin-top: auto;
    }

    .fm-logo {
      width: 90%;
    }
  }

  @include breakpoint('tablet') {
    .sponsor-list {
      position: relative;
      margin-top: auto;
      width: 100%;
    }

    .sponsor-list-items {
      @include scrollbar();

      flex-direction: row;
      justify-content: center;
      overflow-x: auto;

      .sponsor-list-item {
        flex-shrink: 0;
      }

      .to-bottom {
      }

      .fm-logo {
        display: none;
      }
    }
  }

  @include breakpoint('mobile') {
    .sponsor-list {
    }
  }
</style>
